<template>
  <div class="feedback">
    <div class="feedback-header">
      <div class="user-details">
        <img
          v-if="getUserPicture() !== ''"
          :src="getUserPicture()"
          class="user-profile"
        />
        <div class="user-image" v-else></div>
        <h3>{{ feedback.user.first_name }} {{ feedback.user.last_name }}</h3>
        <span>{{ feedback.user.email }}</span>
      </div>
      <div class="buttons">
        <button 
          v-if="actionType !== 'rejected'" 
          class="secondary-btn-dark" 
          @click="rejectClicked()">
            REJECT
        </button>
        <button class="secondary-btn-dark" @click="approveClicked()">APPROVE</button>
      </div>
    </div>
    <div class="feedback-body">
      <span>SUBMITTED: {{ formatDate(feedback.created_at) }}</span>
      <p>{{ feedback.message }}</p>
    </div>
  </div> 
</template>

<script>
import { formatDateTime } from '@/utils'
import { updatedFeedback } from '@/api/requests';

export default {
  name: 'UserFeedback',

  props: {
    feedback: {
      type: Object,
      default: () => {}
    },

    actionType: {
      type: String,
      default: 'waiting',
    }
  },

  methods: {
    formatDate(date) {
      return formatDateTime(date);
    },

    getUserPicture() {
      if (this.feedback.image !== "" && this.feedback.image !== null) {
        if (this.feedback.image.indexOf('blob:') > -1) {
          return this.feedback.image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + this.feedback.image;
      }
      return "";
    },

    approveClicked() {
      let payload = {
        status: 'approved'
      };
      updatedFeedback(this.feedback.id, payload).then(response => {
        this.$store.commit('feedback/removeFrom', { type: this.actionType + 'Feedback', value: this.feedback });
        this.$store.commit('feedback/addTo', { type: 'approvedFeedback', value: this.feedback });
        this.$toasted.global.app_success({
          message: "Feedback has been added to approved list."
        });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to add feedback to approved list."
        });
      });
    },

    rejectClicked() {
      let payload = {
        status: 'rejected'
      };
      updatedFeedback(this.feedback.id, payload).then(response => {
        this.$store.commit('feedback/removeFrom', { type: this.actionType + 'Feedback', value: this.feedback });
        this.$store.commit('feedback/addTo', { type: 'rejectedFeedback', value: this.feedback });
        this.$toasted.global.app_success({
          message: "Feedback has been added to rejected list."
        });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to add feedback to rejected list."
        });
      });
    },
  },

  computed: {
    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.feedback {
  background: $sec1;
  margin-bottom: $spacing-base;
  max-width: 700px;

  .feedback-header {
    background: $sec0;
    display: flex;

    .user-details {
      flex: 1;
      padding: $spacing-base;

      .user-image {
        background: #FFF;
        border-radius: 40px;
        width: 40px;
        height: 40px;
        float: left;
        margin-right: $spacing-small;
      }

      .user-profile {
        border-radius: 40px;
        width: 40px;
        height: 40px;
        float: left;
        margin-right: $spacing-small;
      }
      
      h3 {
        color: #FFF;
        font-size: $font-size-medium;
        font-weight: bold;
        margin: 0;
        padding: 0;
        text-transform: uppercase;
      }

      span {
        font-size: $font-size-base;
        color: $sec5;
        text-transform: uppercase;
      }
    }

    .buttons {
      width: auto;
      margin-top: 0;
      align-items: center;
      margin-right: $spacing-base;
    }

    .secondary-btn-dark {
      color: #FFF;
      border-color: #FFF;
    }
  }

  .feedback-body {
    padding: $spacing-small $spacing-base;

    span {
      font-size: $font-size-base;
      color: $sec5;
      font-weight: bold;
    }

    p {
      font-size: $font-size-base;
      color: #FFF;
      padding: 0;
      margin: $spacing-small 0;
    }
  }
}
</style>